import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  DeleteTicket,
  getallTicket,
  UpdateTicketStatus,
} from "../../../Listfunction";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import {stateToHTML} from 'draft-js-export-html';
import SweetAlert from "react-bootstrap-sweetalert";
import Collapse from "react-collapse";

class DonorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      ticket_status: "",
      bulkSelect: [],
      tickerList: [],
      page: 1,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      _notificationSystem: null,
      useraccess: "",
      noRecordFound: false,
      totpageNo: "",
      resolved_Modal: false,
      resolved_reason: "",
      resolved_user_email: "",
      resolved_user_email_Error: null,
      user_email_state: "",
      selectedTickets: [],
      detailView: false,
      currentTicket: "",
      status: "To Do",
      activeIndex: "",
    };
    this.onChange = this.onChange.bind(this);
    this.SearchDate = this.SearchDate.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.addticket = this.addticket.bind(this);
    this.editTicket = this.editTicket.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
      this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }
  
    onEditorStateChange = (editorState) => {
      this.setState({ resolved_user_email: editorState });
  }

  handleSuccess(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{message}</div>,
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      useraccess: token.role,
    });

    this.SearchDate(this.state.page);
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  SearchDate = (page) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getallTicket(obj, page, this.state.status)
      .then((res) => {
        if (res.success == true) {
          var data = res.data;
          if (data.data.length > 0) {
            let ticket_chk = [];

            data.data.map((ele) => {
              ele["isChecked"] = false;
              ticket_chk.push(ele);
            });
            this.setState({
              tickerList: ticket_chk,
            });

            var no_pages = [];
            let serach_string = "";
            for (var i = 1; i <= data.last_page; i++) {
              if (serach_string == "") {
                no_pages.push(i);
              } else {
                no_pages.push(i);
              }
            }

            if (data.current_page == data.last_page) {
              this.setState({ prevdisabled: null });
              this.setState({ nextdisabled: "1" });
            } else if (data.current_page == 1) {
              this.setState({ nextdisabled: null });
              this.setState({ prevdisabled: "1" });
            } else {
              this.setState({ nextdisabled: null });
              this.setState({ prevdisabled: null });
            }
            if (data.last_page == 1) {
              this.setState({ nextdisabled: 1 });
              this.setState({ prevdisabled: 1 });
            }
            if (data.length == 0) {
              no_pages = [];
              this.setState({ nextdisabled: 1 });
              this.setState({ prevdisabled: 1 });
            }
            this.setState({ currentPage: data.current_page });
            if (data.next_page_url != null) {
              if (serach_string == "") {
                this.setState({
                  nextpage: data.next_page_url.substring(
                    data.next_page_url.indexOf("=") + 1
                  ),
                });
              } else {
                this.setState({
                  nextpage: data.next_page_url.substring(
                    data.next_page_url.indexOf("=") + 1
                  ),
                });
              }
            } else {
              this.setState({ nextpage: "#" });
            }
            if (data.prev_page_url != null) {
              if (serach_string == "") {
                this.setState({
                  prevpage: data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1
                  ),
                });
              } else {
                this.setState({
                  prevpage: data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1
                  ),
                });
              }
            } else {
              this.setState({ prevpage: "#" });
            }

            this.setState({
              loading: false,
              donorList: data.data,
              totpageNo: data.last_page,
              paginationData: no_pages,
            });
          }
        }
      })
      .catch(() => this.handleNetworkError("bl"));
  };

  resetSearch(e) {
    setTimeout(
      function () {
        this.SearchDate(1);
      }.bind(this),
      1000
    );
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  paginationinfo(url) {
    this.SearchDate(url);
  }

  addticket() {
    this.props.history.push("/admin/addticket");
  }

  async handleUpdateStatus(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let sts_arr = [];

    if (this.state.ticket_status != "" && this.state.ticket_status != null) {
      let tick_list = this.state.tickerList;
      tick_list.map((item) => {
        if (item.isChecked) {
          sts_arr.push({ id: item.id, status: this.state.ticket_status });
        }
      });

      if (sts_arr.length > 0) {
        if(this.state.ticket_status === 'Resolved') {
          this.setState({resolved_Modal: true, selectedTickets: sts_arr});
        } else {
        UpdateTicketStatus(obj, sts_arr)
          .then((res) => {
            if (res.success == true) {
              this.SearchDate(this.state.page);
              this.handleSuccess("bl", "Ticket status updated successfully");
            } else {
              console.log(res);
            }
          })
          .catch(() => {
            this.handleNetworkError("bl");
          });
        }
      } else {
        this.setState({
          alert: (
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              Please select at least one ticket
            </SweetAlert>
          ),
        });
      }
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            Please select ticket status
          </SweetAlert>
        ),
      });
    }
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleAllChecked = (event) => {
    let tick_list = this.state.tickerList;
    tick_list.forEach((st) => (st.isChecked = event.target.checked));
    this.setState({ tickerList: tick_list });
  };

  handleCheckChieldElement = (event) => {
    let tick_list = this.state.tickerList;
    tick_list.forEach((st) => {
      if (st.id == event.target.value) {
        st.isChecked = event.target.checked;
      }
    });
    this.setState({ tickerList: tick_list });
  };

  capitalizeFirstLetter = (string) => {
    if (string != "" && string != null && string != undefined) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return "";
    }
  };

  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteticket(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Ticket Detail!
        </SweetAlert>
      ),
    });
  }

  deleteticket = (id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    DeleteTicket(obj, id)
      .then((res) => {
        if (res.success == true) {
          this.handleSuccess("bl", "Ticket deleted successfully");
        } else {
          console.log(res);
        }
        this.SearchDate(this.state.page);
        this.hideAlert();
      })
      .catch(() => {
        this.handleNetworkError("bl");
        this.hideAlert();
      });
  };

  editTicket = (id) => {
    localStorage.setItem("tic_id", id);
    this.props.history.push("/admin/editticket");
  };

  viewticketDetails = (cus) => {
    this.setState({
      currentTicket: cus,
      detailView: true,
    });
  };

  changeactiveIndex = (i) => {
    if (this.state.activeIndex == i) {
      this.setState({
        activeIndex: "",
      });
    } else {
      this.setState({
        activeIndex: i,
      });
    }
  };

  closeResolvedModal = () => {
    this.setState({
    selectedTickets: [],
      bulkSelect: "",
    });
    this.setState({
      resolved_Modal: false,
    })
    this.setState({
    ticket_status:"", 
    selectedTickets: [],
    resolved_reason:"",
   resolved_user_email:""
  })
    this.SearchDate();
  }

  submitResolvedModal = () => {
    let error = false;
    if (this.state.resolved_user_email.length == 0) {
        error = true;
        this.setState({
            resolved_user_email_Error: (
            <small className="text-danger">Please enter the Email Body.</small>
        ),
      });
    } else {
      this.setState({ resolved_user_email_Error: null });
    }

    if (!error) {
      this.setState({ loading: true });
      this.setState({sts_arr:true})
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      console.log("tess");

      var resolved_user_emailInfo = draftToHtml(convertToRaw(this.state.resolved_user_email.getCurrentContent()))
      console.log(resolved_user_emailInfo);
      console.log("test");
      
      this.setState({
        bulkSelect: "",
        ticket_status:"", 
        resolved_user_email:""
      });
      // this.SearchDate();

      UpdateTicketStatus(obj, this.state.selectedTickets, resolved_user_emailInfo)
            .then((res) => {
              if (res.success == true) {
                this.SearchDate(this.state.page);
                this.handleSuccess("bl", "Ticket status updated successfully");
              } else {
                console.log(res);

              }
            })
            .catch(() => {
              this.handleNetworkError("bl");
            });
            this.setState({ 
              resolved_Modal: false ,
              selectedTickets: [],
              bulkSelect: ""
          })
          }
  }

  render() {
    var c = 1;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            tableFullWidth
            content={
              <>
                <Row style={{ padding: 10 }}>
                  <Col sm={4} className="fl_status_dropdown">
                    <select
                      onChange={this.onChange}
                      name="ticket_status"
                      value={this.state.ticket_status}
                      className="form-control"
                    >
                      <option value="">Select Status</option>
                      <option value="To Do">To Do</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Resolved">Resolved</option>
                    </select>
                  </Col>
                  <Col sm={3}>
                    <Button
                      className="fl_btn_change_order_status btn-fill"
                      class="btn-color"
                      fill
                      onClick={() =>{ this.handleUpdateStatus()
                      }}
                    >
                      Change Status
                    </Button>
                  </Col>
                  <Col sm={5} className="text-right">
                    <Button
                      className="fl_btn_add_order btn-fill"
                      class="btn-color"
                      fill
                      onClick={this.addticket.bind(this)}
                    >
                      Add Ticket <i className="fa fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
                <Row
                  className="OrderList_fill"
                  style={{
                    borderRadius: "5px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    width: "98%",
                    marginLeft: "7px",
                  }}
                >
                  <Col sm={6} md={4}>
                    <select
                      name="status"
                      onChange={(e) =>
                        this.setState({
                          status: e.target.value,
                        })
                      }
                      value={this.state.status}
                      className="form-control"
                    >
                      <option value="To Do">To Do</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Resolved">Resolved</option>
                    </select>
                  </Col>
                  <Col
                    lg={1}
                    sm={2}
                    className="fl_mb_1"
                    style={{
                      paddingRight: "5px",
                    }}
                  >
                    <Button
                      onClick={() => this.SearchDate(1)}
                      class="btn-color"
                      style={{ width: "100%" }}
                      fill
                    >
                      Filter
                    </Button>
                  </Col>
                  <Col
                    lg={1}
                    sm={2}
                    className="fl_mb_1"
                    style={{
                      paddingRight: "5px",
                    }}
                  >
                    <Button
                      onClick={() => {
                        this.setState({
                          status: "To Do",
                        });
                        setTimeout(() => this.SearchDate(1), 500);
                      }}
                      class="btn-color"
                      style={{ width: "100%" }}
                      fill
                    >
                      Reset
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              onClick={this.handleAllChecked}
                              value="checkedall"
                            />{" "}
                          </th>
                          <th>Ticket ID</th>
                          <th>Ticket Type</th>
                          <th>Platform</th>
                          <th>Severity</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th>Created By</th>
                          <th>Created At</th>
                          <th>Attachment</th>
                          <th className="text-right">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ? (
                          <tr>
                            <td colspan="10">
                              <LoadingSpinner />
                            </td>
                          </tr>
                        ) : this.state.tickerList.length == 0 ? (
                          <tr>
                            <td colspan="10">
                              <center>No record found</center>
                            </td>
                          </tr>
                        ) : (
                          <React.Fragment>
                            {this.state.tickerList.map((cus, i) => (
                              <tr key={i}>
                                <td>
                                  <input
                                    key={cus.id}
                                    onClick={this.handleCheckChieldElement}
                                    type="checkbox"
                                    checked={cus.isChecked}
                                    value={cus.id}
                                  />{" "}
                                </td>
                                <td>{cus.id}</td>
                                <td>{cus.type}</td>
                                <td>{cus.platform}</td>
                                <td>{cus.priority ? cus.priority : "-"}</td>
                                <td
                                  className="description_content"
                                  onClick={() => this.changeactiveIndex(i)}
                                >
                                  <Collapse isOpened={true}>
                                    <div
                                      className={
                                        this.state.activeIndex == i
                                          ? "collepseble_description"
                                          : "initial_description"
                                      }
                                    >
                                      {" "}
                                      {cus.description}
                                    </div>
                                  </Collapse>
                                </td>
                                <td>
                                  <p
                                    className={`btn btn-fill ${
                                      cus.status == "Resolved"
                                        ? "fl_text_green"
                                        : cus.status == "In Progress"
                                        ? "fl_text_orange"
                                        : ""
                                    }`}
                                  >
                                    {cus.status == "pending"
                                      ? "To Do"
                                      : cus.status}
                                  </p>
                                </td>
                                <td>{cus.lead ? cus.lead.name : ""}</td>
                                <td>{cus.created_at}</td>
                                <td
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "5px",
                                  }}
                                >
                                  {cus.files && cus.files.length > 0
                                    ? cus.files.map((url, idx) => (
                                        <a
                                          href={url}
                                          target="_blank"
                                          className="ticket_attachments_link"
                                        >
                                          File {idx + 1}
                                        </a>
                                      ))
                                    : "NA"}
                                </td>
                                <td className="text-right">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={edit}
                                  >
                                    <Button
                                      simple
                                      bsStyle="success"
                                      onClick={this.editTicket.bind(
                                        this,
                                        cus.id,
                                        cus.channel
                                      )}
                                      bsSize="xs"
                                    >
                                      <i className="fa fa-pencil" />
                                    </Button>
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                    placement="top"
                                    overlay={remove}
                                  >
                                    <Button
                                      simple
                                      bsStyle="danger"
                                      onClick={this.warningWithConfirmAndCancelMessage.bind(
                                        this,
                                        cus.id
                                      )}
                                      bsSize="xs"
                                    >
                                      <i className="fa fa-times" />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        )}
                      </tbody>
                    </Table>

                    <Modal
                          show={this.state.resolved_Modal}
                          onHide={() =>
                            this.setState({ resolved_Modal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Email Body</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                              <>
                                <FormGroup>
                                  {/* <ControlLabel>Email Body</ControlLabel> */}
                                  <Editor
                                  style={{height:"auto !important"}}
                                    editorState={this.state.resolved_user_email}
                                    editorClassName="terms-editor-email"
                                    onEditorStateChange={this.onEditorStateChange}
                                    placeholder="Enter User's Body"
                                  />
                                  {this.state.resolved_user_email_Error}
                                </FormGroup>
                              </>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitResolvedModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeResolvedModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>

                    {this.state.loading
                      ? ""
                      : this.state.noRecordFound
                      ? ""
                      : this.state.totpageNo > 1 && (
                        <>
                          <div style={{ textAlign: "center" }}>
                            <Pagination>
                              <Pagination.First
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.prevpage
                                )}
                                disabled={this.state.prevdisabled}
                              />
                              {this.state.paginationData.map((url) => (
                                <Pagination.Item
                                  active={
                                    this.state.currentPage == c ? "1" : null
                                  }
                                  onClick={this.paginationinfo.bind(this, url)}
                                >
                                  {c++}
                                </Pagination.Item>
                              ))}
                              <Pagination.Last
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.nextpage
                                )}
                                disabled={this.state.nextdisabled}
                              />
                            </Pagination>
                          </div>
                          </>
                        )}
                  </Col>
                </Row>
              </>
            }
          />
        </Grid>

        <Modal
          show={this.state.detailView}
          onHide={() => this.setState({ detailView: true })}
        >
          <Modal.Header>
            <Modal.Title>
              {this.state.currentTicket
                ? `${this.state.currentTicket.type}(${this.state.currentTicket.id})`
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <h6>Platform</h6>
                <p>{this.state.currentTicket.platform}</p>
              </Col>
              <Col sm={6}>
                <h6>Severity</h6>
                <p>{this.state.currentTicket.priority}</p>
              </Col>

              <Col sm={12}>
                <h6>Description</h6>
                <p>{this.state.currentTicket.description} </p>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="success"
              fill
              onClick={() => this.setState({ detailView: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default DonorList;
